














































import { Vue, Component, Prop } from "@/shared/vuepack";
import S3Uploader from "@/shared/components/s3Uploader.vue";
import CensusUploadRules from "@/employer/components/profile/CensusUploadRules.vue";
import EmployeeNavigatorWidget from "@/employer/components/widgets/EmployeeNavigatorWidget.vue";
import { CensusManager } from "@/employer/types";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserStore } from "@/shared/store/user";
import { useEmployeeStore } from "@/employer/store/employee";

@Component({
  components: {
    S3Uploader,
    CensusUploadRules,
    EmployeeNavigatorWidget
  }
})
export default class CensusUpload extends Vue {
  userStore = useUserStore();
  notifierStore = useNotifierStore();
  employeeStore = useEmployeeStore();

  @Prop()
  bucketName: string;
  @Prop()
  afterFileUploaded: (watchFile: string) => void;
  @Prop()
  routeToStateList;

  identifier = String(Math.round((new Date()).getTime() / 1000));

  get inKey () {
    return "census/$identityid/in/" + this.fileNameWithoutExtension() + ".csv";
  }

  get employerId (): number {
    if (this.userStore.currentEmployer && this.userStore.currentEmployer.employerId) {
      return this.userStore.currentEmployer.employerId;
    }

    return 0;
  }

  get allowCensusUpload (): boolean {
    return false;
  }

  get showNavigatorWidget (): boolean {
    return this.userStore.currentEmployer && this.userStore.currentEmployer.censusManager === CensusManager.employeeNavigator;
  }

  fileNameWithoutExtension () {
    return `${this.employerId}.${this.identifier}`;
  }

  uploaded (data) {
    this.employeeStore.clear();
    this.employeeStore.uploadCensusFile({ employerId: this.employerId, s3Key: data.remoteFileName } as any)
      .then(_ => this.afterFileUploaded(this.fileNameWithoutExtension()));
  }

  handleError (err: any): void {
    this.notifierStore.setDanger(err || "Error processing your request. Please try again later");
  }
}
